export enum UtilisationCuissonEnum {
  UTILISATION_CUISSON_PLAQUES = 'UTILISATION_CUISSON_PLAQUES',
  UTILISATION_CUISSON_FOUR = 'UTILISATION_CUISSON_FOUR',
  UTILISATION_CUISSON_FOUR_ET_PLAQUES = 'UTILISATION_CUISSON_FOUR_ET_PLAQUES',
}
